import { render } from "./bundle.vue?vue&type=template&id=85ff0b5c&scoped=true"
import script from "./bundle.vue?vue&type=script&lang=js"
export * from "./bundle.vue?vue&type=script&lang=js"

import "./bundle.vue?vue&type=style&index=0&id=85ff0b5c&scoped=true&lang=css"

import exportComponent from "/Users/alexey/Projects/gambody-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ff0b5c"]])

export default __exports__